(() => {
  const root = document.getElementById("ns-landing");
  if (!root) return;

  const navbarWrapper = document.getElementById("nsNavbarWrapper");
  const navbarInner = document.getElementById("nsNavbarInner");
  const hero = document.getElementById("hero-section");
  const perfectFor = document.getElementById("perfect-for");
  const cta = document.getElementById("cta-section");

  const mobileBtn = document.getElementById("nsMobileCtaBtn");
  const drawer = document.getElementById("nsDrawer");

  if (!navbarWrapper || !navbarInner) return;

  function setDrawerOpen(open) {
    if (!drawer) return;
    drawer.classList.toggle("ns-isOpen", open);
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
    document.body.style.overflow = open ? "hidden" : "";
  }

  function handleScroll() {
    const scrollY = window.scrollY || window.pageYOffset || 0;

    // isScrolled = scrollY > 50 (same as Navbar.tsx)
    const isScrolled = scrollY > 50;
    navbarWrapper.classList.toggle("ns-isScrolled", isScrolled);

    // Determine whether navbar is over dark sections:
    // Dark sections: hero (top) + CTA (bottom); light sections in between.
    let isOverDark = false;

    // Hero check
    if (hero) {
      const heroHeight = hero.offsetHeight || 0;
      if (scrollY < (heroHeight - 100)) isOverDark = true;
    } else {
      if (scrollY < 800) isOverDark = true;
    }

    // CTA overlap check
    if (cta && !isOverDark) {
      const ctaRect = cta.getBoundingClientRect();
      if (ctaRect.top < 120 && ctaRect.bottom > 0) isOverDark = true;
    }

    // Perfect For overlap check (dark section)
    if (perfectFor && !isOverDark) {
      const rect = perfectFor.getBoundingClientRect();
      if (rect.top < 120 && rect.bottom > 0) isOverDark = true;
    }

    const isLightBg = !isOverDark;
    navbarInner.classList.toggle("ns-isLightBg", isLightBg);
  }

  // Scroll listeners
  window.addEventListener("scroll", handleScroll, { passive: true });
  window.addEventListener("resize", handleScroll);
  handleScroll();

  // Drawer interactions
  if (mobileBtn) {
    mobileBtn.addEventListener("click", () => setDrawerOpen(true));
  }
  // Hero / other CTAs
  root.querySelectorAll('[data-open-drawer="true"]').forEach((el) => {
    el.addEventListener("click", () => setDrawerOpen(true));
  });

  // Footer year (keep copyright up-to-date)
  const yearEl = document.getElementById("nsCopyrightYear");
  if (yearEl) yearEl.textContent = String(new Date().getFullYear());

  if (drawer) {
    drawer.addEventListener("click", (e) => {
      const target = e.target;
      if (!(target instanceof HTMLElement)) return;
      if (target.dataset.close === "true") setDrawerOpen(false);
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") setDrawerOpen(false);
    });
  }


  const section = document.getElementById("how-it-works");
  const images = root.querySelectorAll(".ns-phone-image");
  const stepTitles = root.querySelectorAll(".ns-step-title");
  const stepItems = root.querySelectorAll(".ns-hiw-step");

  const TOTAL = 3;

  function clamp(v, min = 0, max = 1) {
    return Math.min(max, Math.max(min, v));
  }

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function getScrollProgress() {
    if (!section) return 0;
    const rect = section.getBoundingClientRect();
    const scrollable = rect.height - window.innerHeight;
    const scrolled = -rect.top;
    return clamp(scrolled / scrollable);
  }

  /* ---------- Image Crossfade ---------- */
  function updateImages(progress) {
    const stepSize = 1 / TOTAL;

    images.forEach((img, index) => {
      const start = index * stepSize;
      const end = (index + 1) * stepSize;

      let opacity = 0;

      if (index === 0) {
        opacity = progress < 0.33 ? 1 : progress < 0.36 ? lerp(1, 0, (progress - 0.33) / 0.03) : 0;
      } else if (index === TOTAL - 1) {
        opacity = progress > 0.66 ? 1 : progress > 0.63 ? lerp(0, 1, (progress - 0.63) / 0.03) : 0;
      } else {
        if (progress >= start && progress <= end) {
          opacity = 1;
        }
      }

      img.style.opacity = opacity;
    });
  }

  /* ---------- Text Reveal ---------- */
  function splitText() {
    stepTitles.forEach((title) => {
      const words = title.innerText.split(" ");
      title.innerHTML = "";

      words.forEach((word) => {
        const wordSpan = document.createElement("span");
        wordSpan.style.whiteSpace = "nowrap";
        wordSpan.style.marginRight = "0.3em";

        [...word].forEach((char) => {
          const span = document.createElement("span");
          span.textContent = char;
          wordSpan.appendChild(span);
        });

        title.appendChild(wordSpan);
      });
    });
  }

  function getActiveIndex(progress) {
    // Split into 3 equal segments: [0..0.33), [0.33..0.66), [0.66..1]
    if (progress < 0.33) return 0;
    if (progress < 0.66) return 1;
    return 2;
  }

  function updateText(progress) {
    const stepSize = 1 / TOTAL;

    stepTitles.forEach((title, index) => {
      const start = index * stepSize;
      const chars = title.querySelectorAll("span span");

      chars.forEach((char, i) => {
        const charProgress = i / chars.length;
        const charStart = start + charProgress * stepSize * 0.8;
        const charEnd = charStart + 0.05;

        const t = clamp((progress - charStart) / (charEnd - charStart));
        const color = t > 0 ? "#292929" : "#e5e7eb";
        char.style.color = color;
      });
    });

    const active = getActiveIndex(progress);
    stepItems.forEach((el, i) => {
      el.classList.toggle("is-active", i === active);
    });
  }

  /* ---------- Scroll Loop ---------- */
  if (section) {
    splitText();

    function onScroll() {
      const progress = getScrollProgress();
      updateImages(progress);
      updateText(progress);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }




  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target); // once: true
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: "-100px"
    }
  );

  root.querySelectorAll(".ns-reveal").forEach(el => {
    observer.observe(el);
  });




  const tags = [
    "Busy professionals",
    "Fitness beginners",
    "Weight-loss journeys",
    "Health-conscious eaters",
    "Anyone who hates logging food",
    "Busy parents",
    "Athletes"
  ];

  // 自动生成 tag 元素并复制 3 次实现无缝滚动
  root.querySelectorAll(".ns-marquee-row").forEach((row, index) => {
    const rawDirection = row.dataset.direction;
    const direction = rawDirection === "right" ? "right" : "left";
    const speed = Number(row.dataset.speed);

    const items = direction === "right" ? [...tags].reverse() : [...tags];
    const allItems = [...items, ...items, ...items]; // triple for smooth scroll

    allItems.forEach(text => {
      const tag = document.createElement("div");
      tag.className = "ns-tag inactive";
      tag.textContent = text;
      row.appendChild(tag);
    });

    const prefersReducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    if (prefersReducedMotion) return;

    // 设置动画：按 data-speed（秒/圈）做时间驱动的平滑滚动
    const gap = 16;
    const totalWidth = Array.from(row.children).reduce((sum, el) => sum + el.offsetWidth + gap, 0);
    const distance = totalWidth / 3;
    const durationSec = Number.isFinite(speed) && speed > 0 ? speed : 60;
    const pxPerMs = distance / (durationSec * 1000);

    let start = direction === "right" ? -distance : 0;
    row.style.transform = `translateX(${start}px)`;

    let last = performance.now();
    function animate(now) {
      const dt = now - last;
      last = now;

      start += direction === "left" ? -pxPerMs * dt : pxPerMs * dt;
      if (direction === "left" && start <= -distance) start = 0;
      if (direction === "right" && start >= 0) start = -distance;

      row.style.transform = `translateX(${start}px)`;
      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
  });

  // 中间高亮检测：IntersectionObserver
  const perfectForObserver = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
          entry.target.classList.remove("inactive");
        } else {
          entry.target.classList.add("inactive");
          entry.target.classList.remove("active");
        }
      });
    },
    {
      root: null,
      rootMargin: "0px -35% 0px -35%", // 高亮中间区域（左右收缩）
      threshold: 0
    }
  );

  root.querySelectorAll(".ns-tag").forEach(tag => perfectForObserver.observe(tag));




  // FAQ Accordion（单开合 + 动画 + aria + 默认展开）
  const accordions = root.querySelectorAll(".ns-accordion");

  function closeItem(header, content) {
    if (!header || !content) return;

    const closeTimeoutKey = "accordionCloseTimeoutId";
    const existingTimeout = Number(content.dataset[closeTimeoutKey]);
    if (existingTimeout) window.clearTimeout(existingTimeout);

    // 开始收起动画：先锁定当前高度，再过一帧设为 0
    content.style.maxHeight = `${content.scrollHeight}px`;
    requestAnimationFrame(() => {
      content.style.maxHeight = "0px";
    });

    header.classList.remove("active");
    header.setAttribute("aria-expanded", "false");

    const timeoutId = window.setTimeout(() => {
      content.classList.remove("active");
      content.hidden = true;
      content.style.maxHeight = null;
      delete content.dataset[closeTimeoutKey];
    }, 320);
    content.dataset[closeTimeoutKey] = String(timeoutId);
  }

  function openItem(header, content) {
    if (!header || !content) return;

    const closeTimeoutKey = "accordionCloseTimeoutId";
    const existingTimeout = Number(content.dataset[closeTimeoutKey]);
    if (existingTimeout) window.clearTimeout(existingTimeout);

    content.hidden = false;
    content.classList.add("active");

    header.classList.add("active");
    header.setAttribute("aria-expanded", "true");

    // 过一帧再测量高度，确保 hidden 解除后 scrollHeight 正确
    requestAnimationFrame(() => {
      content.style.maxHeight = `${content.scrollHeight}px`;
    });
  }

  accordions.forEach((accordion) => {
    const headers = accordion.querySelectorAll(".ns-accordion-header");

    headers.forEach((header) => {
      const content = header.nextElementSibling;
      if (!(content instanceof HTMLElement)) return;

      // 初始化：全部关闭（避免无 JS 时的 hidden 行为不一致）
      header.setAttribute("aria-expanded", "false");
      content.hidden = true;
      content.style.maxHeight = null;

      header.addEventListener("click", () => {
        const isOpen = header.classList.contains("active");

        // 先关闭其它已打开项（同一个 accordion 内）
        const activeHeader = accordion.querySelector(".ns-accordion-header.active");
        if (activeHeader && activeHeader !== header) {
          closeItem(activeHeader, activeHeader.nextElementSibling);
        }

        if (isOpen) {
          closeItem(header, content);
        } else {
          openItem(header, content);
        }
      });
    });

    // 默认展开（对齐 React：index=1）
    const defaultOpenIndex = Number(accordion.getAttribute("data-default-open"));
    if (Number.isFinite(defaultOpenIndex) && defaultOpenIndex >= 0) {
      const header = headers[defaultOpenIndex];
      if (header) {
        const content = header.nextElementSibling;
        if (content instanceof HTMLElement) {
          openItem(header, content);
        }
      }
    }
  });



})();
